import ApplicationSerializer from 'lumen/serializers/application';

export default class MfaConfigSerializer extends ApplicationSerializer {
  primaryKey = 'gip_display_name';
}
